import { useLayoutEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { resetDefaultMetaTags } from '../utils/metaTags';

/** Preserve initial server metadata; clear the previous subject on SPA navigation. */
export function RouteShareMetadata() {
  const { pathname } = useLocation();
  const previousPath = useRef(pathname);
  useLayoutEffect(() => {
    if (previousPath.current !== pathname) {
      resetDefaultMetaTags();
      document.getElementById('bilt-json-ld')?.remove();
      previousPath.current = pathname;
    }
  }, [pathname]);
  return null;
}
